import './error.css'
import '../css/webflow.css'
import '../css/normalize.css'
import '../css/life-group.webflow.css'

const Error = () => {  return (
    <div class="hero-section wf-section">
        <div class="container-2 w-container">
            <section class="page_404">
                <div class="container">
                    <div class="row">	
                    <div class="col-sm-12 ">
                    <div class="col-sm-10 col-sm-offset-1  text-center">
                    <div class="four_zero_four_bg">
                        <h1 class="text-center">404</h1>
                    </div>
                    
                    <div class="contant_box_404">
                        <div>
                            <h3 class="h2">
                                Похоже, вы заблудились
                            </h3>
                        </div>    
                        <div>
                            <p>страница, которую вы ищете, недоступна!</p>
                        </div>    
                        <div>
                            <a href="/" class="link_404">На главную</a>
                        </div>    
                </div>
                    </div>
                    </div>
                    </div>
                </div>
            </section>
        </div>    
    </div>
  )
}  

export default Error;